<section class="reale-theme-style2">
  <div fxLayout="column" class="wrapper">
    <header [configuration]="headerConfiguration"></header>
    <app-title [data]="titleData"></app-title>
  </div>

  <form [formGroup]="guaranteeForm" class="form-container">
    <div class="form-field">
      <label class="form-field-label" for="">Número de serie</label>
      <input
        type="text"
        class="form-field-input"
        placeholder="Número de serie"
        aria-label="Number"
        matInput
        formControlName="serialNumber"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <mat-option
          *ngFor="let serial of filteredOptions | async"
          [value]="serial.serialNumber"
        >
          {{ serial.serialNumber }}
        </mat-option>
      </mat-autocomplete>
    </div>

    <div class="form-field">
      <label class="form-field-label" for="">Teléfono</label>
      <input class="form-field-input" type="text" formControlName="phone" />
      <div *ngIf="fieldIsValid(guaranteeForm, 'phone')" class="errorForm">
        *El formato del teléfono no es correcto
      </div>
    </div>
  </form>

  <button [disabled]="guaranteeForm.invalid" (click)="activateAndFinish()">
    Activar Berria Care
  </button>
</section>
<app-footer></app-footer>
